import Vue from "vue";
import Vuex from "vuex";
import survey from "./modules/survey";
import profile from "./modules/profile";
import resource from "./modules/resource";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    survey,
    profile,
    resource
  }
});
